import VaultWorkspace from './VaultWorkspace';
export default VaultWorkspace;
